<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="纪念馆设置" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group class="martop0">
    	<van-cell center title="设为隐私馆">
    	  <template #right-icon>
    	    <van-switch v-model="privateChecked" size="24" active-color="#24a378" @change="checkedchange()"  />
    	  </template>
    	</van-cell>
    	<van-cell center title="升级纪念馆" label="豪华馆尊贵馆钻石馆" is-link to="/MemorialHallUpgrade" />
    	<van-cell center title="在线充值" label="在线充值天堂币" is-link to="/Pay" />
    	<van-cell center title="纪念馆音乐" label="选择纪念馆背影音乐" is-link to="/MemorialHallMusic" />
		<van-cell center title="公开纪念馆申请"  is-link  :to="'/MemorialHallApply?id='+id" />
    </van-cell-group>

    <!-- 隐私馆弹出 -->
    <van-popup round v-model="popShow">
    	<div class="dialog-private">
    	  <h2 class="title">请输入密码</h2>
    	  <div class="control-input">
    	    <input type="text" ref="password" placeholder="" class="van-field__control">
    	  </div>
    	  <van-button round size="small" class="mybtn" @click="submit()">确定</van-button>
    	  <p class="tips">温馨提示:隐私馆只有馆主或者知道密码者方可访问。</p>
        <van-icon name="clear" class="closeBtn" @click="privateChecked = popShow= false"/>
    	</div>
    </van-popup>

  </div>
</template>

<script>
  import { Toast } from "vant"
	export default {
	  data() {
	    return {
			privateChecked:false,
			popShow : false,
			id :0,
			vMemorialHallDetailed:{},
	    };
	  },
	  components: {
    	},
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
			},
			init(){
				var that = this;
				var options = {
					type: "GetMemorialHallSearchApiById",
					id: that.id
				};
				that.$store.dispatch(options).then(res => {
					that.vMemorialHallDetailed = res;
					that.privateChecked = res.MemorialHallSearchApiModel.IsPrivacy;
				});
			},
			checkedchange(){
				var that = this;
				if(that.privateChecked){
					that.popShow = true;
				}else{
					that.$store.dispatch({
						type: "MemorialManageSetMemorialHallPrivacyVue",
						SerialNumber : that.id,
						Password : "",
					}).then(res => {
						that.popShow = false;
					},err => {})
				}
			},
			submit(){
				var that = this;
				if(!(this.$refs.password.value.length > 0)){
					Toast("密码不能为空");
					return;
				}
				that.$store.dispatch({
					type: "MemorialManageSetMemorialHallPrivacyVue",
					SerialNumber : that.id,
					Password : that.$refs.password.value,
				}).then(res => {
					that.privateChecked = true;
					that.popShow = false;
					that.$refs.password.value = "";
					Toast(res.Message);
				},err => {})



			}
		},
		created() {
			var that = this;
			that.id = this.$route.query.id
			that.init();
		}
	}
;
</script>

<style scoped>
</style>
